<template>
  <router-view />
</template>

<script>
export default {
  name: 'monitorMain',
}
</script>
